module.exports = __webpack_public_path__ + "img/1.f28a199d.jpg";